import { NavLink } from "react-router-dom";
import { getUser } from "../../../config/auth";

function TacklLogoMark({ size = 34 }) {
  return (
    <img
      src="/logo.svg"
      alt="Tackl"
      style={{ width: size, height: size, objectFit: "contain", flexShrink: 0 }}
    />
  );
}

function Icon({ name }) {
  const s = { width: 16, height: 16, style: { flexShrink: 0 } };
  const p = { stroke: "currentColor", strokeWidth: 1.75, strokeLinecap: "round", strokeLinejoin: "round", fill: "none" };

  switch (name) {
    case "dashboard":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M4 13h7V4H4v9z" {...p} />
          <path d="M13 20h7V4h-7v16z" {...p} />
          <path d="M4 20h7v-5H4v5z" {...p} />
        </svg>
      );
    case "clients":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" {...p} />
          <circle cx="9" cy="7" r="4" {...p} />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" {...p} />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" {...p} />
        </svg>
      );
    case "projects":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M3 7h18" {...p} />
          <path d="M6 7v12" {...p} />
          <path d="M18 7v12" {...p} />
          <path d="M3 19h18" {...p} />
          <path d="M9 11h6" {...p} />
        </svg>
      );
    case "requests":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M21 15a4 4 0 0 1-4 4H7l-4 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z" {...p} />
          <path d="M8 9h8" {...p} />
          <path d="M8 13h5" {...p} />
        </svg>
      );
    case "approvals":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M9 11l3 3L22 4" {...p} />
          <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" {...p} />
        </svg>
      );
    case "documents":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <path d="M6 2h9l5 5v15H6z" {...p} />
          <path d="M14 2v6h6" {...p} />
          <path d="M9 13h6" {...p} />
          <path d="M9 17h4" {...p} />
        </svg>
      );
    case "invoices":
      return (
        <svg {...s} viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="9" {...p} />
          <path d="M12 7v10" {...p} />
          <path d="M9 10h5a2 2 0 0 1 0 4H9" {...p} />
        </svg>
      );
    default:
      return null;
  }
}

function RailLink({ to, label, icon, onClick }) {
  return (
    <NavLink
      to={to}
      title={label}
      aria-label={label}
      className={({ isActive }) => `sidebar-rail-item${isActive ? " active" : ""}`}
      onClick={onClick}
    >
      <Icon name={icon} />
    </NavLink>
  );
}

function SidebarLink({ to, label, icon, onClick }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) => `sidebar-item${isActive ? " active" : ""}`}
      onClick={onClick}
    >
      <Icon name={icon} />
      <span>{label}</span>
    </NavLink>
  );
}

function SidebarSection({ label }) {
  return (
    <div className="sidebar-section-row">
      <span className="sidebar-section">{label}</span>
    </div>
  );
}

export default function ClientPortalSidebar({ isOpen, onClose }) {
  const user = getUser();
  const role = user?.role || "Staff";
  const initial = (user?.name || user?.email || "?")[0].toUpperCase();

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}

      <aside className={`sidebar client-portal-sidebar${isOpen ? " sidebar--open" : ""}`}>
        <div className="sidebar-primary-rail" aria-label="Client Portal primary navigation">
          <div className="sidebar-rail-logo">
            <TacklLogoMark size={30} />
          </div>
          <nav className="sidebar-rail-nav">
            <RailLink to="/client-portal/dashboard" label="Client Portal Dashboard" icon="dashboard" onClick={onClose} />
          </nav>
        </div>

        <div className="sidebar-panel">
          <div className="sidebar-header">
            <div className="sidebar-brand">
              <div>
                <div className="sidebar-title">Client Portal</div>
                <div className="sidebar-subtitle">Clients, approvals, documents</div>
              </div>
            </div>
            <button className="sidebar-close-btn" onClick={onClose} aria-label="Close menu">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          <nav className="sidebar-nav">
            <SidebarSection label="Portal" />
            <SidebarLink to="/client-portal/dashboard" label="Dashboard" icon="dashboard" onClick={onClose} />
            <SidebarLink to="/client-portal/clients" label="Clients" icon="clients" onClick={onClose} />
            <SidebarLink to="/client-portal/projects" label="Projects" icon="projects" onClick={onClose} />

            <SidebarSection label="Collaboration" />
            <SidebarLink to="/client-portal/requests" label="Requests" icon="requests" onClick={onClose} />
            <SidebarLink to="/client-portal/approvals" label="Approvals" icon="approvals" onClick={onClose} />
            <SidebarLink to="/client-portal/documents" label="Documents" icon="documents" onClick={onClose} />
            <SidebarLink to="/client-portal/invoices" label="Invoices" icon="invoices" onClick={onClose} />
          </nav>

          <div className="sidebar-footer">
            <div className="sidebar-user-row">
              <div className="sidebar-user-avatar">{initial}</div>
              <div className="sidebar-user-info">
                <div className="sidebar-user-name">
                  {user?.name || user?.email?.split("@")[0] || "User"}
                </div>
                <div className="sidebar-user-role">{role}</div>
              </div>
              <span className="sidebar-beta-badge">PORTAL</span>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
